export const ORDER_SERIAL_NUMBERS = {
  no: 0,
  sequence: 1,
  codified: 2
};
